import { useDispatch } from 'react-redux';
import { BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { Close24 } from 'ui/icons/action/Close24';
import { closeNav } from '../ducks/actions';
import {
  HeaderContent,
  NavSliderCloseBtn,
  NavSliderContent,
  NavSliderHeaderWrapper,
} from './NavSlider.styles';

interface NavSliderProps {
  /** Content of the header */
  headerContent?: JSX.Element | string;
  /** Content of header actions */
  headerActions?: JSX.Element;
  /** Callback fired when the slide over is requested to be closed. */
  onClose?: (x?: any) => void;
  /** Callback fired when click outside of slide over content */
  onClickOutside?: (x?: any) => void;
  /** Wrapped Content */
  children?: React.ReactNode;
}

export const NavSlider = ({ onClose, headerActions, headerContent, children }: NavSliderProps) => {
  const dispatch = useDispatch();
  const onCloseBtnClicked = () => {
    if (onClose) {
      onClose();
    } else {
      dispatch(closeNav());
    }
  };

  return (
    <>
      <NavSliderHeaderWrapper data-test={`navslider-header-wrapper`}>
        <HeaderContent>
          <div>{headerContent}</div>
          <NavSliderCloseBtn>
            <IconButton
              onClick={onCloseBtnClicked}
              data-test={`navslider-close-button`}
              variant={BUTTON_VARIANTS.GHOST}
              size={BUTTON_SIZES.LARGE}
            >
              <Close24 />
            </IconButton>
          </NavSliderCloseBtn>
        </HeaderContent>
        {headerActions}
      </NavSliderHeaderWrapper>

      <NavSliderContent data-test={`navslider-content`}>{children}</NavSliderContent>
    </>
  );
};
